import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../auth/stores/authStore';
import { onboardingKeys } from './onboardingKeys';
import {
  getOnboardingStatus,
  OnboardingStatusResponse,
} from '../api/onboardingApi';

export function useOnboardingStatus(enabled = true) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery<OnboardingStatusResponse>({
    queryKey: onboardingKeys.status(),
    queryFn: ({ signal }) => getOnboardingStatus(signal),
    enabled: isAuthenticated && enabled,
    staleTime: 5 * 60 * 1000,
  });
}
